/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-07 11:17:27
 * @LastEditTime: 2019-07-24 14:34:50
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  添加普通仓库需求发布
const createInfoUrl = '/website/storage/demand'

//  添加罐区需求发布
const createTankFarmInfoUrl = '/website/tankFarm/demand'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

/* 查询企业信息 */
const companyNameUrl = `/authentication/get`

// 获取企业信息
export function getCompanyInfo(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + companyNameUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findByUserIdAndCompanyName'
      }, param))
    }
  })
}

// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

//  添加供给发布
export function createInfo(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + createInfoUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandSave'
      }, param))
    }
  })
}

//  添加供给发布
export function createTankFarmInfo(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + createTankFarmInfoUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandSave'
      }, param))
    }
  })
}

